const data = {
  title: "Get your custom demo and quote",
  fields: {
    name: {
      id: "input-name",
      name: "name",
      type: "text",
      placeholder: "Name",
    },
    email: {
      id: "input-email",
      name: "email",
      type: "text",
      placeholder: "Email",
    },
    dropdowns: {
      companySize: {
        id: "enterpriseForm",
        options: ["0-50", "50-150", "150+"],
        isRequired: true,
      },
    },
  },

  submit: {
    text: "Let's go",
  },
};

import { useState, useEffect, useRef } from "react";
import Script from "next/script";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../../styles/cssinjs/helpers/variables.js";

import {
  StyledForm,
  StyledInput,
  StyledHeading,
  StyledDropdown,
  StyledToast,
  StyledSubmit,
  StyledError,
} from "../../../../styles/cssinjs/components/StyledForm";

import validate from "../../../../util/forms/validation";
import IntlInput from "./IntlInput";
import submitEnterprise from "../../../../util/forms/submit/enterprise";

export default function EnterpriseForm({ reqCountry }) {
  const [nameErrorStatus, setNameErrorStatus] = useState(null);
  const [nameErrorMsg, setNameErrorMsg] = useState("");
  const [emailErrorStatus, setEmailErrorStatus] = useState(null);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [phoneErrorStatus, setPhoneErrorStatus] = useState(null);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState("");
  const [dropdownErrorStatus, setDropdownErrorStatus] = useState(null);
  const [dropdownErrorMsg, setDropdownErrorMsg] = useState("");

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState(null);

  const [toastMsg, setToastMsg] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [hasThankYouScreen, setThankYouScreen] = useState(false);
  const [isWindowReady, setWindowReady] = useState(false);

  useEffect(() => {
    setWindowReady(true);
  }, [isWindowReady]);
  function handleSubmit(e) {
    e.preventDefault();
    let form = e.target;
    let details = {};
    details.phone = form.phone.value;
    details.dialCode = form.dialCode.value;
    details.countryCode = form.countryCode.value;
    const { errors, isFormValid } = validate(data.fields, e.target);

    setNameErrorStatus(errors.status?.name);
    setNameErrorMsg(errors.message?.name);
    setEmailErrorStatus(errors.status?.email);
    setEmailErrorMsg(errors.message?.email);
    setPhoneErrorStatus(errors.status?.phone);
    setPhoneErrorMsg(errors.message?.phone);
    setDropdownErrorStatus(errors.status?.companySizeDropdown);
    setDropdownErrorMsg(errors.message?.companySizeDropdown);

    if (isFormValid === true) {
      submitEnterprise(
        form,
        setToastMsg,
        setDisableSubmit,
        setThankYouScreen,
        details
      );
    }
  }

  function handleDropdown(e) {
    setDropdownOpen(!isDropdownOpen);
  }

  function resetForm() {
    let form = document.querySelector(".jsx-form");
    setThankYouScreen(false);
    setDisableSubmit(false);
    setDropdownValue(null);
  }

  return (
    <>
      <StyledForm>
        <form
          noValidate
          method="post"
          className={`jsx-form form-wrap md:mb-2 lg:mb-2 w-100`}
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="toast-wrap">
            {toastMsg !== "" && <StyledToast>{toastMsg}</StyledToast>}
          </div>
          <fieldset>
            <StyledHeading>{data.title}</StyledHeading>
            <>
              <div>
                <StyledInput>
                  <input
                    id={data.fields.name.id}
                    type={data.fields.name.type}
                    name={data.fields.name.name}
                    placeholder={data.fields.name.placeholder}
                    className={`${nameErrorStatus ? `error` : ``}`}
                  />
                  {nameErrorStatus && <StyledError>{nameErrorMsg}</StyledError>}
                </StyledInput>
                <StyledInput>
                  <input
                    id={data.fields.email.id}
                    type={data.fields.email.type}
                    name={data.fields.email.name}
                    placeholder={data.fields.email.placeholder}
                    className={`${emailErrorStatus ? `error` : ``}`}
                  />
                  {emailErrorStatus && (
                    <StyledError>{emailErrorMsg}</StyledError>
                  )}
                </StyledInput>
                {isWindowReady && (
                  <IntlInput
                    reqCountry={reqCountry}
                    errorStatus={phoneErrorStatus}
                    errorMessage={phoneErrorMsg}
                  />
                )}
                <StyledDropdown>
                  <input
                    type="text"
                    hidden
                    name="company"
                    defaultValue={dropdownValue !== null ? dropdownValue : ``}
                  />
                  <div
                    id={data.fields.dropdowns.companySize.id}
                    className={`${isDropdownOpen ? `open` : ``} ${
                      dropdownValue !== null ? `selected` : ``
                    }`}
                    onClick={(e) => {
                      handleDropdown(e);
                    }}
                  >
                    <div className="jsx-dropdown-current" id="">
                      <span
                        id="form-dropdown-value"
                        data-value={
                          dropdownValue === null ? "undefined" : dropdownValue
                        }
                      >
                        {dropdownValue === null
                          ? `Company size`
                          : dropdownValue}
                      </span>
                      <i className="jsx-drop-arrow"></i>
                    </div>
                    {dropdownErrorStatus && (
                      <StyledError>{dropdownErrorMsg}</StyledError>
                    )}
                    <div className="jsx-dropdown-menu">
                      <ul>
                        {data.fields.dropdowns.companySize.options.map(
                          (item, index) => {
                            return (
                              <li
                                key={index}
                                onClick={(e) => {
                                  setDropdownValue(e.target.innerText);
                                }}
                              >
                                {item}
                              </li>
                            );
                          }
                        )}
                      </ul>
                    </div>
                  </div>
                </StyledDropdown>
              </div>
              <StyledSubmit>
                <button
                  type="submit"
                  className={`jsx-btn-primary ${
                    disableSubmit ? `disabled` : ``
                  }`}
                >
                  {data.submit.text}
                </button>
              </StyledSubmit>
            </>
          </fieldset>
          {hasThankYouScreen && (
            <EnterpriseThankYouScreen resetForm={resetForm} />
          )}
        </form>
      </StyledForm>
      <Script
        src="https://assets.setmore.com/website/next/scripts/vendor/validate.js"
        strategy="afterInteractive"
      />
      <Script
        src="https://assets.setmore.com/website/next/scripts/vendor/intl-tel-input-utils.js"
        strategy="afterInteractive"
      />
    </>
  );
}

const EnterpriseThankYouScreen = ({ resetForm }) => {
  return (
    <article className="lg:pt-12.5 br-8">
      <i>
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M16.8749 0.208313C7.67017 0.208313 0.208252 7.67023 0.208252 16.875C0.208252 26.0797 7.67017 33.5416 16.8749 33.5416C26.0797 33.5416 33.5416 26.0797 33.5416 16.875C33.5416 7.67023 26.0797 0.208313 16.8749 0.208313ZM16.8749 2.52428C24.8006 2.52428 31.2256 8.94931 31.2256 16.875C31.2256 24.8007 24.8006 31.2257 16.8749 31.2257C8.94925 31.2257 2.52422 24.8007 2.52422 16.875C2.52422 8.94931 8.94925 2.52428 16.8749 2.52428ZM10.9509 16.6109L14.4283 20.0883L23.0489 11.468C23.4953 11.0217 24.2189 11.0217 24.6652 11.468C25.0671 11.87 25.1112 12.5041 24.7524 12.9854L24.6652 13.0843L15.2366 22.5129C14.8347 22.9148 14.2006 22.9589 13.7193 22.6L13.6204 22.5129L9.33465 18.2271C8.88834 17.7808 8.88834 17.0572 9.33465 16.6109C9.73658 16.209 10.3707 16.1649 10.852 16.5237L10.9509 16.6109Z"
            fill="#2FD793"
          ></path>
        </svg>
      </i>
      <h3 className="fw-700 mt-2 mb-2 text-md">
        Thanks for sharing your details.
      </h3>
      <p className="text-smx text-grey mb-5">
        One of our Setmore experts will be in touch shortly.
      </p>
      <button
        className="jsx-btn-primary"
        onClick={() => {
          resetForm();
        }}
      >
        Start again
      </button>
      <style jsx>{`
        article {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: ${colors.primitive.white.default};
          padding: 90px;
          text-align: center;
          z-index: 5;
        }
        h3 {
          font-size: ${font.size.md[2]};
          margin: 16px 0;
        }
        p {
          font-size: ${font.size.sm[4]};
          line-height: ${lineHeight[7]};
        }
        @media (max-width: ${viewport.mobile.md}) {
          article {
            padding: 20px;
          }
        }
      `}</style>
    </article>
  );
};
